// extracted by mini-css-extract-plugin
export default {"logo":"DialogPane_logo__s28-z","header":"DialogPane_header__Pbpvf","body":"DialogPane_body__tJy7a"};